import React, { useState } from "react"

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

// Manual "Sync now" (doc 10). POSTs to enqueue an incremental Partner API pull,
// then hands off to the parent which polls the ledger until the run completes
// (the job is async — the worker + Shopify round-trip take longer than a single
// refetch). Disabled while a sync is in flight; the freshness line shows when
// data was last pulled. Owner/admin only (canSync from policy).
export function SyncNowButton({ syncPath, lastSyncedAt, syncing, onSyncStart, copy }) {
  const [note, setNote] = useState(null)

  const sync = async () => {
    setNote(null)
    try {
      const res = await fetch(syncPath, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken(), Accept: "application/json" },
      })
      if (res.status === 429) {
        const body = await res.json().catch(() => ({}))
        setNote(body.error || copy.sync.throttled)
        return
      }
      if (!res.ok) throw new Error("sync failed")
      setNote(copy.sync.requested)
      onSyncStart && onSyncStart()
    } catch {
      setNote(copy.states.error)
    }
  }

  const freshness = lastSyncedAt
    ? copy.sync.last_synced.replace("%{time}", new Date(lastSyncedAt).toLocaleString())
    : copy.sync.never

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        onClick={sync}
        disabled={syncing}
        className="inline-flex items-center rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {syncing ? copy.sync.syncing : copy.sync.now}
      </button>
      <p className="text-xs text-gray-400 dark:text-gray-500">{note || freshness}</p>
    </div>
  )
}
